// import React, { useState } from "react";
// import CustomButton from "../../../../atoms/CustomButton";
// import { Calendar } from "lucide-react";
// import SideOverlay from "../../../../atoms/SideOverlay";
// import { ChevronLeft, ChevronRight } from "lucide-react";
// import './styles.scss'

// const mockTasks = [
//   { id: "1", title: "Team Meeting", date: new Date(), completed: false },
//   { id: "2", title: "Project Review", date: new Date(), completed: true },
//   { id: "2", title: "Project Review", date: new Date(), completed: true },
//   { id: "2", title: "Project Review", date: new Date(), completed: true },
//   { id: "2", title: "Project Review", date: new Date(), completed: true },
//   { id: "2", title: "Project Review", date: new Date(), completed: true },
//   {
//     id: "3",
//     title: "Client Call",
//     date: new Date(Date.now() + 86400000),
//     completed: false,
//   },
// ];

// const CalendarComponent = () => {
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [isWeekView, setIsWeekView] = useState(true);

//   const getWeekDates = (date) => {
//     const week = [];
//     const start = new Date(date);
//     start.setDate(start.getDate() - start.getDay());

//     for (let i = 0; i < 7; i++) {
//       week.push(new Date(start));
//       start.setDate(start.getDate() + 1);
//     }
//     return week;
//   };

//   const weekDates = getWeekDates(selectedDate);

//   const navigateWeek = (direction) => {
//     const newDate = new Date(selectedDate);
//     newDate.setDate(newDate.getDate() + (direction === "next" ? 7 : -7));
//     setSelectedDate(newDate);
//   };

//   const getTasksForDate = (date) => {
//     return mockTasks.filter(
//       (task) => task.date.toDateString() === date.toDateString()
//     );
//   };

//   const formatDate = (date) => {
//     return new Intl.DateTimeFormat("en-US", {
//       weekday: "short",
//       month: "short",
//       day: "numeric",
//     }).format(date);
//   };

//   return (
//     <div className="calendar">
//       <div className="calendar-header">
//         <button onClick={() => navigateWeek("prev")}>
//           <ChevronLeft size={20} />
//         </button>
//         <h2>{isWeekView ? "Week View" : "Day View"}</h2>
//         <button onClick={() => navigateWeek("next")}>
//           <ChevronRight size={20} />
//         </button>
//       </div>

//       <div className="view-toggle">
//         <button
//           className={isWeekView ? "active" : ""}
//           onClick={() => setIsWeekView(true)}
//         >
//           Week
//         </button>
//         <button
//           className={!isWeekView ? "active" : ""}
//           onClick={() => setIsWeekView(false)}
//         >
//           Day
//         </button>
//       </div>

//       {isWeekView ? (
//         <div className="week-view">
//           {weekDates.map((date, index) => (
//             <div
//               key={index}
//               className={`day-column ${
//                 date.toDateString() === new Date().toDateString() ? "today" : ""
//               }`}
//               onClick={() => {
//                 setSelectedDate(date);
//                 setIsWeekView(false);
//               }}
//             >
//               <div className="date-header">{formatDate(date)}</div>
//               <div className="tasks">
//                 {getTasksForDate(date).map((task) => (
//                   <div
//                     key={task.id}
//                     className={`task ${task.completed ? "completed" : ""}`}
//                   >
//                     {task.title}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className="day-view">
//           <h3>{formatDate(selectedDate)}</h3>
//           <div className="tasks">
//             {getTasksForDate(selectedDate).map((task) => (
//               <div
//                 key={task.id}
//                 className={`task ${task.completed ? "completed" : ""}`}
//               >
//                 {task.title}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const CalenderView = () => {
//   const [open, setOpen] = useState();
//   return (
//     <>
//       <button
//         className="btn-primary btn"
//         style={{ padding: 0, minWidth: "60px" }}
//         onClick={() => setOpen(true)}
//       >
//         <Calendar size={18} />
//       </button>

//       <SideOverlay
//         isOpen={open}
//         side="right"
//         onClose={() => setOpen(false)}
//         width="80%"
//         title="Calender View"
//       >
//         <CalendarComponent />
//       </SideOverlay>
//     </>
//   );
// };

// export default CalenderView;

// ----------------------------------------------- 

// import React, { useState } from "react";
// import CustomButton from "../../../../atoms/CustomButton";
// import { Calendar } from "lucide-react";
// import SideOverlay from "../../../../atoms/SideOverlay";
// import { ChevronLeft, ChevronRight } from "lucide-react";
// import "./styles.scss";

// const mockTasks = [
//   {
//     id: "1",
//     title: "Team Meeting",
//     date: new Date(),
//     completed: false,
//     user: "Alice",
//   },
//   {
//     id: "2",
//     title: "Project Review",
//     date: new Date(),
//     completed: true,
//     user: "Bob",
//   },
//   {
//     id: "3",
//     title: "Client Call",
//     date: new Date(Date.now() + 86400000),
//     completed: false,
//     user: "Alice",
//   },
//   {
//     id: "4",
//     title: "Design Review",
//     date: new Date(),
//     completed: true,
//     user: "Charlie",
//   },
//   {
//     id: "5",
//     title: "Code Review",
//     date: new Date(),
//     completed: false,
//     user: "Bob",
//   },
// ];

// const CalendarComponent = () => {
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [isWeekView, setIsWeekView] = useState(true);
//   const [groupByUser, setGroupByUser] = useState(false);

//   const getWeekDates = (date) => {
//     const week = [];
//     const start = new Date(date);
//     start.setDate(start.getDate() - start.getDay());

//     for (let i = 0; i < 7; i++) {
//       week.push(new Date(start));
//       start.setDate(start.getDate() + 1);
//     }
//     return week;
//   };

//   const weekDates = getWeekDates(selectedDate);

//   const navigateWeek = (direction) => {
//     const newDate = new Date(selectedDate);
//     newDate.setDate(newDate.getDate() + (direction === "next" ? 7 : -7));
//     setSelectedDate(newDate);
//   };

//   const getTasksForDate = (date) => {
//     const tasks = mockTasks.filter(
//       (task) => task.date.toDateString() === date.toDateString()
//     );

//     if (groupByUser) {
//       const groupedTasks = tasks.reduce((acc, task) => {
//         acc[task.user] = acc[task.user] || [];
//         acc[task.user].push(task);
//         return acc;
//       }, {});
//       return groupedTasks;
//     }

//     return tasks;
//   };

//   const formatDate = (date) => {
//     return new Intl.DateTimeFormat("en-US", {
//       weekday: "short",
//       month: "short",
//       day: "numeric",
//     }).format(date);
//   };

//   return (
//     <div className="calendar">
//       <div className="calendar-header">
//         <button onClick={() => navigateWeek("prev")}>
//           <ChevronLeft size={20} />
//         </button>
//         <h2>{isWeekView ? "Week View" : "Day View"}</h2>
//         <button onClick={() => navigateWeek("next")}>
//           <ChevronRight size={20} />
//         </button>
//       </div>

//       <div className="d-flex gap-3">
//         <div className="view-toggle">
//           <button
//             className={isWeekView ? "active" : ""}
//             onClick={() => setIsWeekView(true)}
//           >
//             Week
//           </button>
//           <button
//             className={!isWeekView ? "active" : ""}
//             onClick={() => setIsWeekView(false)}
//           >
//             Day
//           </button>
//         </div>

//         <div className="view-toggle">
//           <button
//             className={groupByUser ? "active" : ""}
//             onClick={() => setGroupByUser(true)}
//           >
//             Group by User
//           </button>
//           <button
//             className={!groupByUser ? "active" : ""}
//             onClick={() => setGroupByUser(false)}
//           >
//             Group by None
//           </button>
//         </div>
//       </div>

//       {isWeekView ? (
//         <div className="week-view">
//           {weekDates.map((date, index) => (
//             <div
//               key={index}
//               className={`day-column ${
//                 date.toDateString() === new Date().toDateString() ? "today" : ""
//               }`}
//               onClick={() => {
//                 setSelectedDate(date);
//                 setIsWeekView(false);
//               }}
//             >
//               <div className="date-header">{formatDate(date)}</div>
//               <div className="tasks">
//                 {!groupByUser
//                   ? getTasksForDate(date).map((task) => (
//                       <div
//                         key={task.id}
//                         className={`task ${task.completed ? "completed" : ""}`}
//                       >
//                         {task.title}
//                       </div>
//                     ))
//                   : Object.entries(getTasksForDate(date)).map(
//                       ([user, tasks]) => (
//                         <div key={user} className="task-group">
//                           <h6>{user}</h6>
//                           {tasks.map((task) => (
//                             <div
//                               key={task.id}
//                               className={`task ${
//                                 task.completed ? "completed" : ""
//                               }`}
//                             >
//                               {task.title}
//                             </div>
//                           ))}
//                         </div>
//                       )
//                     )}
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className="day-view">
//           <h3>{formatDate(selectedDate)}</h3>
//           <div className="tasks">
//             {!groupByUser
//               ? getTasksForDate(selectedDate).map((task) => (
//                   <div
//                     key={task.id}
//                     className={`task ${task.completed ? "completed" : ""}`}
//                   >
//                     {task.title}
//                   </div>
//                 ))
//               : Object.entries(getTasksForDate(selectedDate)).map(
//                   ([user, tasks]) => (
//                     <div key={user} className="task-group">
//                       <h6>{user}</h6>
//                       {tasks.map((task) => (
//                         <div
//                           key={task.id}
//                           className={`task ${
//                             task.completed ? "completed" : ""
//                           }`}
//                         >
//                           {task.title}
//                         </div>
//                       ))}
//                     </div>
//                   )
//                 )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const CalenderView = () => {
//   const [open, setOpen] = useState();
//   return (
//     <>
//       <button
//         className="btn-primary btn"
//         style={{ padding: 0, minWidth: "60px" }}
//         onClick={() => setOpen(true)}
//       >
//         <Calendar size={18} />
//       </button>

//       <SideOverlay
//         isOpen={open}
//         side="right"
//         onClose={() => setOpen(false)}
//         width="80%"
//         title="Calender View"
//       >
//         <CalendarComponent />
//       </SideOverlay>
//     </>
//   );
// };

// export default CalenderView;

//  -----------------------------------------------

import React, { useState } from "react";
import CustomButton from "../../../../atoms/CustomButton";
import { Calendar, ChevronDown, ChevronUp } from "lucide-react";
import SideOverlay from "../../../../atoms/SideOverlay";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./styles.scss";

const mockTasks = [
  { id: "1", title: "Team Meeting", date: new Date(), completed: false, assignedTo: "Alice" },
  { id: "2", title: "Project Review", date: new Date(), completed: true, assignedTo: "Bob" },
  { id: "3", title: "Client Call", date: new Date(Date.now() + 86400000), completed: false, assignedTo: "Alice" },
  { id: "4", title: "Code Review", date: new Date(Date.now() + 86400000), completed: true, assignedTo: "Charlie" },
  { id: "5", title: "Design Review", date: new Date(), completed: false, assignedTo: "Bob" },
];

const CalendarComponent = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isWeekView, setIsWeekView] = useState(true);
  const [collapsedUsers, setCollapsedUsers] = useState({});

  const getWeekDates = (date) => {
    const week = [];
    const start = new Date(date);
    start.setDate(start.getDate() - start.getDay());

    for (let i = 0; i < 7; i++) {
      week.push(new Date(start));
      start.setDate(start.getDate() + 1);
    }
    return week;
  };

  const weekDates = getWeekDates(selectedDate);

  const navigateWeek = (direction) => {
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() + (direction === "next" ? 7 : -7));
    setSelectedDate(newDate);
  };

  const getTasksForDate = (date) => {
    return mockTasks.filter(
      (task) => task.date.toDateString() === date.toDateString()
    );
  };

  const groupTasksByUser = (tasks) => {
    return tasks.reduce((acc, task) => {
      if (!acc[task.assignedTo]) {
        acc[task.assignedTo] = [];
      }
      acc[task.assignedTo].push(task);
      return acc;
    }, {});
  };

  const toggleUserCollapse = (user) => {
    setCollapsedUsers((prev) => ({
      ...prev,
      [user]: !prev[user],
    }));
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
    }).format(date);
  };

  return (
    <div className="calendar">
      <div className="calendar-header">
        <button onClick={() => navigateWeek("prev")}>
          <ChevronLeft size={20} />
        </button>
        <h2>{isWeekView ? "Week View" : "Day View"}</h2>
        <button onClick={() => navigateWeek("next")}>
          <ChevronRight size={20} />
        </button>
      </div>

      <div className="view-toggle">
        <button
          className={isWeekView ? "active" : ""}
          onClick={() => setIsWeekView(true)}
        >
          Week
        </button>
        <button
          className={!isWeekView ? "active" : ""}
          onClick={() => setIsWeekView(false)}
        >
          Day
        </button>
      </div>

      {isWeekView ? (
        <div className="week-view">
          {weekDates.map((date, index) => {
            const tasksForDate = getTasksForDate(date);
            const groupedTasks = groupTasksByUser(tasksForDate);

            return (
              <div key={index} className="day-column">
                <div className="date-header">{formatDate(date)}</div>
                {Object.entries(groupedTasks).map(([user, tasks]) => (
                  <div key={user} className="user-group">
                    <div className="user-header" onClick={() => toggleUserCollapse(user)}>
                      {user}
                      {collapsedUsers[user] ? <ChevronDown /> : <ChevronUp />}
                    </div>
                    {!collapsedUsers[user] && (
                      <div className="tasks">
                        {tasks.map((task) => (
                          <div
                            key={task.id}
                            className={`task ${task.completed ? "completed" : ""}`}
                          >
                            {task.title}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="day-view">
          <h3>{formatDate(selectedDate)}</h3>
          {Object.entries(groupTasksByUser(getTasksForDate(selectedDate))).map(([user, tasks]) => (
            <div key={user} className="user-group">
              <div className="user-header" onClick={() => toggleUserCollapse(user)}>
                {user}
                {collapsedUsers[user] ? <ChevronDown /> : <ChevronUp />}
              </div>
              {!collapsedUsers[user] && (
                <div className="tasks">
                  {tasks.map((task) => (
                    <div
                      key={task.id}
                      className={`task ${task.completed ? "completed" : ""}`}
                    >
                      {task.title}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const CalenderView = () => {
  const [open, setOpen] = useState();
  return (
    <>
      <button
        className="btn-primary btn"
        style={{ padding: 0, minWidth: "60px" }}
        onClick={() => setOpen(true)}
      >
        <Calendar size={18} />
      </button>

      <SideOverlay
        isOpen={open}
        side="right"
        onClose={() => setOpen(false)}
        width="80%"
        title="Calender View"
      >
        <CalendarComponent />
      </SideOverlay>
    </>
  );
};

export default CalenderView;

